import React from 'react';
import { Box, Typography } from '@mui/material';

interface LeadsHeaderProps {}

export const LeadsHeader: React.FC<LeadsHeaderProps> = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>Leads</Typography>
    </Box>
  );
};

